const asset = (name) => `/api/assets/${name}`;

export const site = {
  name: "The Gelato Spot",
  legalName: "The Gelato Spot Wood Fired Pizzeria",
  tagline: "Neapolitan wood-fired pizza and gelato in Phoenix",
  description:
    "The Gelato Spot serves Neapolitan wood-fired pizza, gelato, panini, salads, wine, coffee, and catering at 32nd Street and Shea in Phoenix.",
  domain: "https://gelato.spot",
  assets: {
    logoWhite: asset("optimized/gelato-spot-logo-v3-white.webp"),
    logoBlack: asset("optimized/gelato-spot-logo-v3-black.webp"),
    hero: asset("optimized/gs-image-cover.webp"),
    baking: asset("optimized/gs-images-baking.webp"),
    redGelato: asset("optimized/gs-image-red-gelato.webp"),
    patioOne: asset("optimized/a6a2564-fullsize.webp"),
    patioTwo: asset("optimized/a6a2575-fullsize.webp"),
    truck: asset("optimized/truck-example-2.webp"),
    panini: asset("optimized/panini.webp"),
    cone: asset("optimized/gs-image-icecream-cone-1.webp"),
    counter: asset("optimized/gs-image-slot-69.webp"),
    gelatoCase: asset("optimized/gelatoimage3.webp"),
    beveragePour: asset("optimized/a6a2541-fullsize.webp"),
    cocktail: asset("optimized/cocktail-1040857-1920.webp"),
    pizza: asset("optimized/bgt05945-1-1024x636.webp"),
    cateringHero: asset("optimized/gelatocateringheader.webp"),
    cateringCart: asset("optimized/gelatoimage2.webp"),
    cateringTable: asset("optimized/catering-table-top-pic-scaled.webp"),
    cakes: asset("optimized/gelato-cakes-scaled.webp"),
    server: asset("optimized/adisyn-gelato-catering.webp")
  }
};

export const contact = {
  phone: "(602) 494-4010",
  phoneHref: "tel:16024944010",
  email: "hello@gelato.spot",
  emailHref: "mailto:hello@gelato.spot",
  address: "10608 North 32nd Street, Phoenix, AZ 85028",
  shortAddress: "32nd Street and Shea, behind Walgreens",
  mapsUrl: "https://maps.app.goo.gl/MNNB3b9jjXbgiMWR7",
  mapEmbed:
    "https://www.google.com/maps?q=10608%20North%2032nd%20Street%2C%20Phoenix%2C%20AZ%2085028&output=embed",
  orderUrl: "https://online.skytab.com/455d18c0bd65ea2bfe9942cbc5eb5eb1",
  delivery: [
    {
      label: "DoorDash",
      href: "https://www.doordash.com/store/the-gelato-spot-wood-fired-pizzeria-phoenix-1171266/41103548/"
    },
    {
      label: "Grubhub",
      href: "https://www.grubhub.com/restaurant/wood-fired-pizzeria-gelato-spot-10608-n-32nd-st-phoenix/1010793"
    },
    {
      label: "Uber Eats",
      href: "https://www.ubereats.com/store/the-gelato-spot-32nd-st/NaQr4CCfSfSirUOFDBNSJw"
    }
  ],
  socials: [
    { label: "Facebook", href: "https://www.facebook.com/thegelatospot/" },
    { label: "Instagram", href: "http://instagram.com/gelatospot" },
    { label: "X", href: "https://x.com/gelatospot" },
    { label: "Mastodon", href: "https://mastodon.social/@gelatospot" },
    { label: "Bluesky", href: "https://bsky.app/profile/gelatospot.bsky.social" }
  ]
};

export const locationHours = [
  { day: "Sunday", open: "11:30", close: "20:30" },
  { day: "Monday", closed: true },
  { day: "Tuesday", open: "11:30", close: "20:30" },
  { day: "Wednesday", open: "11:30", close: "20:30" },
  { day: "Thursday", open: "11:30", close: "20:30" },
  { day: "Friday", open: "11:30", close: "21:30" },
  { day: "Saturday", open: "11:30", close: "21:30" }
];

export const navItems = [
  { label: "Home", href: "/" },
  { label: "Menu", href: "/menu/" },
  { label: "Location", href: "/location/" },
  { label: "About Us", href: "/about-us/" },
  { label: "Catering", href: "/catering/" },
  { label: "FAQ", href: "/frequently-asked-questions-faq/" }
];

export const sitemapPages = [
  { title: "Home", path: "/", lastmod: "2026-07-10" },
  { title: "Menu", path: "/menu/", lastmod: "2026-07-10" },
  { title: "Location", path: "/location/", lastmod: "2026-07-10" },
  { title: "About Us", path: "/about-us/", lastmod: "2026-07-10" },
  { title: "Catering", path: "/catering/", lastmod: "2026-07-10" },
  { title: "Join Gelato Spot Updates", path: "/join/", lastmod: "2026-07-11" },
  { title: "Developers", path: "/developers/", lastmod: "2026-09-03" },
  {
    title: "Frequently Asked Questions",
    path: "/frequently-asked-questions-faq/",
    lastmod: "2025-08-28"
  },
  { title: "Privacy Policy", path: "/privacy-policy/", lastmod: "2026-07-10" },
  {
    title: "Terms and Conditions",
    path: "/terms-and-conditions/",
    lastmod: "2025-08-28"
  }
];

export const routeMeta = {
  "/": {
    title: "The Gelato Spot | Neapolitan Pizza and Gelato in Phoenix",
    description:
      "Visit The Gelato Spot at 32nd Street and Shea for Neapolitan wood-fired pizza, house-made gelato, panini, salads, and catering."
  },
  "/menu/": {
    title: "The Gelato Spot Pizzeria Menu | 32nd St and Shea | Phoenix, AZ",
    description:
      "Browse The Gelato Spot menu for Neapolitan wood-fired pizza, gelato, panini, salads, drinks, coffee, beer, wine, and happy hour."
  },
  "/location/": {
    title: "The Gelato Spot Location | 32nd Street and Shea in Phoenix",
    description:
      "Visit The Gelato Spot at 10608 North 32nd Street in Phoenix for gelato, Neapolitan wood-fired pizza, cakes, panini, and catering."
  },
  "/about-us/": {
    title: "About Us | The Gelato Spot",
    description:
      "Learn how The Gelato Spot brings Northern Italian gelato techniques and Neapolitan wood-fired pizza to Phoenix."
  },
  "/catering/": {
    title: "Catering | The Gelato Spot",
    description:
      "Book Gelato Spot catering for Phoenix metro events with gelato, Neapolitan wood-fired pizza, panini, salads, cakes, and service."
  },
  "/join/": {
    title: "Join Gelato Spot Updates | Phoenix Pizza and Gelato",
    description:
      "Sign up for occasional Gelato Spot news, specials, flavors, and events at 32nd Street and Shea in Phoenix."
  },
  "/frequently-asked-questions-faq/": {
    title: "Frequently Asked Questions | The Gelato Spot",
    description:
      "Answers about The Gelato Spot location, gluten-free options, music, contact, pickup, and delivery."
  },
  "/privacy-policy/": {
    title: "Privacy Policy | The Gelato Spot",
    description: "Privacy policy for The Gelato Spot website and related online services."
  },
  "/terms-and-conditions/": {
    title: "Terms and Conditions | The Gelato Spot",
    description: "Terms and conditions for The Gelato Spot website and related services."
  },
  "/preferences/": {
    title: "Email Preferences | The Gelato Spot",
    description: "Manage promotional email preferences for The Gelato Spot."
  },
  "/developers/": {
    title: "Developers | The Gelato Spot Public API and MCP",
    description:
      "Connect applications and AI assistants to The Gelato Spot public menu, flavors, hours, catering estimates, REST API, and MCP server."
  },
  "/sign-in/": {
    title: "Staff Sign In | The Gelato Spot",
    description: "Shared Manna Agency staff sign-in for Gelato Spot site tools."
  },
  "/admin/": {
    title: "Admin | The Gelato Spot",
    description: "Gelato Spot admin tools for menu, flavors, and catering settings."
  }
};

export const homeHighlights = [
  {
    eyebrow: "Neapolitan pizza",
    title: "Neapolitan crust straight from the wood-fired oven",
    body: "Neapolitan-style crusts, crushed tomatoes, fresh mozzarella, and wood-fired toppings make the menu feel like a full meal, not just dessert.",
    image: site.assets.pizza
  },
  {
    eyebrow: "Gelato",
    title: "Northern Italian technique, made in Phoenix",
    body: "The Gelato Spot was built around imported ingredients, old-world standards, and a deep respect for gelato craft.",
    image: site.assets.redGelato
  },
  {
    eyebrow: "Events",
    title: "Catering across the Phoenix metro area",
    body: "Gelato carts, wood fired pizza, panini, salads, and cakes can come to company meetings, parties, fairs, and pop-up activations.",
    image: site.assets.truck
  }
];

export const menuSections = [
  {
    title: "Appetizers",
    items: [
      {
        name: "Roasted Meatballs",
        price: "$11",
        description: "Mozzarella, parmesan cheese, fresh basil, and garlic bread."
      },
      {
        name: "Garlic Bread",
        price: "$10",
        description: "Covered in parmesan and mozzarella cheeses."
      },
      {
        name: "Garlic Knots",
        price: "$9",
        description: "With cheese on top for $10.",
        tags: ["secret", "hidden", "garlic", "knots", "cheese"],
        isSecret: true
      },
      {
        name: "Caprese Salad",
        price: "$13",
        description:
          "Marinated roasted tomatoes, tomato jam, arugula, warm bread with extra virgin olive oil, balsamic, and sea salt."
      },
      {
        name: "Bruschetta",
        price: "$13",
        description:
          "Ripe tomatoes, fresh basil, extra virgin olive oil, and aged balsamic."
      },
      {
        name: "Roasted Cauliflower",
        price: "$13",
        description:
          "Golden raisins, pesto vinaigrette, radishes, and parmesan cheese."
      },
      {
        name: "Trio",
        price: "$13",
        description:
          "Marinara parmesan dip, pesto dip, olive oil with balsamic glaze, and focaccia wedges."
      }
    ]
  },
  {
    title: "Panini",
    note: "All paninis come with a bag of chips. Lunch from 11:30AM to 5PM is $13. Dinner from 5PM to close is $15.",
    items: [
      {
        name: "Chicken Louie Sandwich",
        price: "$13-15",
        description:
          "Grilled chicken breast, fresh tomato, smoked bacon, avocado, Louie dressing, and gorgonzola crumbles."
      },
      {
        name: "Sausage and Peppers",
        price: "$13-15",
        description:
          "Hot Italian sausage, scratch marinara, provolone, roasted red peppers, and wood-fired onions."
      },
      {
        name: "Turkey and Bacon",
        price: "$13-15",
        description:
          "Turkey, bacon bits, romaine, tomatoes, red onions, avocado, provolone cheese, and mayo."
      },
      {
        name: "Veggie Panini",
        price: "$13-15",
        description:
          "Roasted eggplant, wood-fired onions and zucchini, roasted red peppers, fresh tomatoes, provolone, fresh mozzarella, and basil."
      },
      {
        name: "Grinder",
        price: "$13-15",
        description:
          "Italian ham, hot soppressata, melted provolone, gaeta olives, tomato, romaine, chile pepper oil, and oregano."
      },
      {
        name: "Meatball",
        price: "$13-15",
        description: "Meatball, marinara sauce, provolone cheese, and oregano."
      }
    ]
  },
  {
    title: "Wood Fired Pizza",
    note: "Neapolitan-style crusts with crushed tomatoes and fresh mozzarella. 10\" lunch pizzas are $13 from 11:30AM to 5PM. 12\" pizzas are $15 and available all night. Gluten-free dough is available on 12\" pizza for $4.",
    items: [
      {
        name: "Margherita",
        price: "$13-15",
        description: "Crushed tomatoes, fresh mozzarella, and fresh basil."
      },
      {
        name: "Cheese",
        price: "$13-15",
        description:
          "Crushed tomatoes, fresh mozzarella, provolone cheese, and shaved parmesan."
      },
      {
        name: "Ari Pizza",
        price: "$13-$15",
        description: "Fresh mozzarella, parmesan, and kalamata olives.",
        tags: ["secret", "hidden", "pizza", "fresh mozzarella", "parmesan", "kalamata olives"],
        isSecret: true
      },
      {
        name: "Pepperoni",
        price: "$13-15",
        description: "Crushed tomatoes, fresh mozzarella, spicy pepperoni, and parmesan."
      },
      {
        name: "American",
        price: "$13-15",
        description:
          "Crushed tomatoes, fresh mozzarella, spicy pepperoni, hot Italian sausage, and parmesan."
      },
      {
        name: "Testarossa",
        price: "$13-15",
        description:
          "Crushed tomatoes, fresh mozzarella, spicy pepperoni, roasted red peppers, wood-fired onions, gaeta olives, crushed garlic, and oregano."
      },
      {
        name: "Veggie",
        price: "$13-15",
        description:
          "Red or white pizza with fresh mozzarella, roasted eggplant, roasted red peppers, fresh mushrooms, wood-fired onions, and fresh basil."
      },
      {
        name: "Pig and Pineapple",
        price: "$13-15",
        description: "Italian ham, fresh golden pineapple, fresh basil, and parmesan."
      },
      {
        name: "Capricossa",
        price: "$13-15",
        description:
          "Italian ham, gaeta olives, fresh mushrooms, marinated artichokes, and fresh basil."
      },
      {
        name: "Honey Basil",
        price: "$13-15",
        description:
          "Fresh mozzarella, gorgonzola, basil, parmesan, and honey drizzle."
      },
      {
        name: "BBQ Chicken",
        price: "$13-15",
        description:
          "Homemade chipotle BBQ, grilled chicken, fresh mozzarella, caramelized onions, and bacon."
      },
      {
        name: "Meatball",
        price: "$13-15",
        description:
          "Marinara sauce, fresh mozzarella, sliced meatballs, parmesan cheese, and oregano."
      }
    ]
  },
  {
    title: "Salads and Pasta",
    note: "House-made dressings include balsamic vinaigrette, champagne vinaigrette, Louie dressing, aioli dressing, and Caesar dressing.",
    items: [
      {
        name: "Roasted Veggie Kale Salad",
        price: "$13-15",
        description:
          "Kale, roasted red peppers, roasted eggplant, grilled zucchini, tomatoes, roasted corn, balsamic vinaigrette, and bread."
      },
      {
        name: "Focaccia Chicken Caesar",
        price: "$13-15",
        description:
          "Mixed greens, grilled chicken breast, shaved parmesan, Caesar dressing, and cherry tomatoes on focaccia."
      },
      {
        name: "Focaccia Chop Salad",
        price: "$13-15",
        description:
          "Mixed greens, cucumbers, carrots, avocado, roasted corn, tomatoes, shaved parmesan, and champagne vinaigrette on focaccia. Add chicken for $2."
      },
      {
        name: "Louie Wedge Salad",
        price: "$13-15",
        description:
          "Iceberg wedge with Louie dressing, chicken, tomatoes, cucumbers, avocado, bacon bits, champagne vinaigrette, and hardboiled egg."
      },
      {
        name: "House Salad or Caesar Salad",
        price: "$5",
        description: "A simple side salad option."
      },
      {
        name: "Spaghetti and Meatballs",
        price: "$11-16",
        description: "Rustic wood fire-roasted tomato in a pink sauce."
      },
      {
        name: "Rigatoni Bolognese",
        price: "$11-16",
        description: "Topped with fresh ricotta."
      }
    ]
  },
  {
    title: "Gelato",
    note: "Come in to see the constantly evolving variety of gelato flavors.",
    items: [
      { name: "One Flavor Gelato", price: "$4.50", description: "" },
      { name: "Two Flavor Gelato", price: "$5.50", description: "" },
      { name: "Three Flavor Gelato", price: "$6.50", description: "" },
      {
        name: "Cookies and Cream",
        price: "",
        description: "Sweet cream gelato folded with chocolate cookie pieces.",
        tags: ["classic", "cookie", "chocolate", "sweet cream"],
        imageUrl: asset("optimized/cookies-and-cream-gelato.webp"),
        imageAlt: "Cookies and cream gelato"
      },
      {
        name: "Vegan Chocolate",
        price: "",
        description: "Rich dairy-free chocolate gelato with a smooth cocoa finish.",
        tags: ["vegan", "chocolate", "dairy-free", "cocoa"]
      },
      {
        name: "Strawberry",
        price: "",
        description: "Bright strawberry gelato with a fresh fruit finish.",
        tags: ["fruit", "strawberry", "classic", "refreshing"]
      },
      {
        name: "Lemon",
        price: "",
        description: "Tart lemon gelato with a clean, refreshing citrus finish.",
        tags: ["fruit", "citrus", "lemon", "refreshing"]
      },
      {
        name: "Mango",
        price: "",
        description: "Sunny mango gelato with ripe tropical fruit flavor.",
        tags: ["fruit", "mango", "tropical", "refreshing"]
      },
      {
        name: "Butter Pecan",
        price: "",
        description: "Buttery gelato with toasted pecans and a warm caramel note.",
        tags: ["nutty", "pecan", "caramel", "classic"]
      },
      {
        name: "Raspberry",
        price: "",
        description: "Sweet-tart raspberry gelato with a bright berry finish.",
        tags: ["fruit", "raspberry", "berry", "refreshing"]
      },
      {
        name: "Nutella",
        price: "",
        description: "Creamy chocolate hazelnut gelato inspired by Nutella.",
        tags: ["chocolate", "hazelnut", "nutty", "rich"]
      },
      {
        name: "Vanilla Bean",
        price: "",
        description: "Smooth vanilla gelato flecked with real vanilla bean.",
        tags: ["classic", "vanilla", "vanilla bean", "creamy"]
      },
      {
        name: "Banana Pudding",
        price: "",
        description: "Creamy banana gelato with nostalgic pudding-shop flavor.",
        tags: ["banana", "dessert", "creamy", "comfort"]
      },
      {
        name: "Almond Snickers",
        price: "",
        description: "Chocolate caramel gelato with almond crunch and candy-bar richness.",
        tags: ["chocolate", "almond", "caramel", "nutty"]
      },
      {
        name: "Coconut",
        price: "",
        description: "Creamy coconut gelato with a mellow tropical finish.",
        tags: ["coconut", "tropical", "creamy", "classic"]
      },
      {
        name: "Mint Chocolate Chip",
        price: "",
        description: "Cool mint gelato with crisp chocolate chips in every bite.",
        tags: ["mint", "chocolate", "classic", "refreshing"]
      },
      {
        name: "Roasted Almond",
        price: "",
        description: "Toasty almond gelato with a rich roasted nut finish.",
        tags: ["almond", "nutty", "roasted", "classic"]
      },
      {
        name: "Biscoff",
        price: "",
        description: "Cookie butter gelato with warm spice and caramelized cookie flavor.",
        tags: ["cookie butter", "biscoff", "spiced", "cookie"]
      },
      {
        name: "Cake Batter",
        price: "",
        description: "Sweet cake batter gelato with a creamy bakery-style finish.",
        tags: ["cake", "dessert", "sweet", "kid favorite"]
      },
      {
        name: "Peanut Butter",
        price: "",
        description: "Creamy peanut butter gelato with a salty-sweet finish.",
        tags: ["peanut butter", "nutty", "salty-sweet", "classic"]
      },
      {
        name: "Caramel Fudge Brownie",
        price: "",
        description: "Caramel gelato with fudgy brownie pieces and chocolate ribbons.",
        tags: ["caramel", "brownie", "chocolate", "rich"]
      },
      {
        name: "Chocolate",
        price: "",
        description: "Classic chocolate gelato with a deep cocoa flavor.",
        tags: ["classic", "chocolate", "cocoa", "rich"]
      },
      {
        name: "Vanilla Latte",
        price: "",
        description: "Vanilla gelato with smooth espresso and coffeehouse flavor.",
        tags: ["coffee", "espresso", "vanilla", "latte"]
      },
      {
        name: "Stracciatella",
        price: "",
        description: "Sweet milk gelato threaded with delicate chocolate flakes.",
        tags: ["classic", "chocolate", "italian", "stracciatella"]
      },
      {
        name: "Cotton Candy",
        price: "",
        description: "Playful cotton candy gelato with a light spun-sugar sweetness.",
        tags: ["kid favorite", "cotton candy", "sweet", "colorful"]
      },
      {
        name: "Sea Salt Caramel",
        price: "",
        description: "Caramel gelato balanced with a clean sea salt finish.",
        tags: ["caramel", "sea salt", "salty-sweet", "classic"]
      },
      {
        name: "Bubble Gum",
        price: "",
        description: "Bright bubble gum gelato with a nostalgic candy-shop flavor.",
        tags: ["kid favorite", "bubble gum", "candy", "sweet"]
      },
      {
        name: "Pumpkin",
        price: "",
        description: "Pumpkin gelato with warm fall spice and a creamy finish.",
        tags: ["pumpkin", "fall", "seasonal", "spiced"],
        isOutOfSeason: true
      },
      {
        name: "Captain Crunch",
        price: "",
        description: "Cereal-milk gelato with crunchy golden cereal flavor.",
        tags: ["cereal", "kid favorite", "crunchy", "sweet"],
        isOutOfSeason: true
      },
      {
        name: "Gelato Shake or Root Beer Float",
        price: "$7.50",
        description: "Add two shots of espresso for $1."
      },
      { name: "Affogato", price: "$6.50", description: "Gelato with espresso." },
      {
        name: "Party Pack 500g",
        price: "$19.50",
        description: "Two flavors, serves 4 to 5."
      },
      {
        name: "Party Pack 750g",
        price: "$27.50",
        description: "Two flavors, serves 6 to 8."
      },
      {
        name: "Party Pack 1,000g",
        price: "$31.50",
        description: "Three flavors, serves 10 to 12."
      },
      {
        name: "Mousse Cake",
        price: "$4.25-5",
        description:
          "Coconut macaroon, Italian wedding cookies, brownie sundae, chocolate indulgence, tiramisu, and red velvet.",
        isActive: false
      },
      {
        name: "Toppings",
        price: "$0.60 each",
        description:
          "Rainbow sprinkles, chocolate sprinkles, chocolate chips, gummy bears, Oreo cookies, roasted almond, M&M's, and bubble gum."
      }
    ]
  },
  {
    title: "Beverages",
    items: [
      { name: "Bottled Alkaline Molly Water .5L", price: "$2", description: "" },
      { name: "Bottled Alkaline Molly Water 1L", price: "$3", description: "" },
      { name: "Perrier Sparkling Water", price: "$2.50", description: "" },
      {
        name: "Carbonated Drinks",
        price: "$2.50",
        description: "Coke, Diet Coke, Sprite, Dr. Pepper, Root Beer, and Minute Maid Lemonade."
      },
      { name: "Apple Juice", price: "$3", description: "" },
      { name: "Orange Juice", price: "$3", description: "", isActive: false },
      { name: "Cranberry Juice", price: "$3", description: "", isActive: false },
      {
        name: "Iced Tea",
        price: "$2.50",
        description: "Pomegranate green tea and black tea."
      }
    ]
  },
  {
    title: "Beer, Wine, and Cocktails",
    items: [
      {
        name: "Bottled Beer",
        price: "$5",
        description:
          "Modelo Especial, Huss Scottsdale Blonde, Papago Orange Blonde, Peroni, and SanTan Moon Juice."
      },
      {
        name: "Red Wine",
        price: "$8.50 glass | $34 bottle",
        description:
          "Angeline Pinot Noir, Dona Paula Malbec, Hope's End Red Blend, and Three Thieves Cabernet Sauvignon."
      },
      {
        name: "White Wine",
        price: "$8.50 glass | $34 bottle",
        description: "Pinot Grigio, Pomelo Chardonnay, and Seaglass Sauvignon Blanc."
      },
      {
        name: "Charles & Charles Riesling",
        price: "$8.50 glass | $34 bottle",
        description: "",
        isActive: false
      },
      {
        name: "Mixed Drinks and Cocktails",
        price: "$9",
        description:
          "Moscow Mule, shaken daiquiri, Paloma, classic gin and tonic, and old fashioned."
      }
    ]
  },
  {
    title: "Coffee",
    statusLabel: "Coffee Machine Temporarily Down",
    isStatusActive: true,
    items: [
      { name: "Frozen Frappe", price: "$6.50", description: "" },
      { name: "Espresso", price: "$3", description: "Two shots. Add Baileys or Kahlua for $5." },
      { name: "Americano", price: "$4.50", description: "Hot or iced. Add two extra shots for $2." },
      { name: "Cafe Latte", price: "$4.50", description: "Hot or iced. Add two extra shots for $2." },
      { name: "Chai Tea Latte", price: "$4.50", description: "Hot or iced. Large is $0.50 more." },
      { name: "Cappuccino", price: "$4.50", description: "" },
      { name: "Macchiato", price: "$4.50", description: "" },
      { name: "Hot Chocolate", price: "$4.50", description: "" },
      {
        name: "Add a Flavor",
        price: "$0.55",
        description:
          "Vanilla, caramel, hazelnut, chocolate syrup, white chocolate, and caramel syrup. Sugar-free options available."
      },
      { name: "Add Almond Milk", price: "$0.60", description: "" }
    ]
  },
  {
    title: "Happy Hour",
    note: "Tuesday through Friday, 3PM to 6PM.",
    items: [
      { name: "Margarita Pizza", price: "$9", description: "Lunch sized 10\" pizza." },
      { name: "Pepperoni Pizza", price: "$9", description: "Lunch sized 10\" pizza." },
      { name: "Bruschetta Chicken Caesar Salad", price: "$8", description: "" },
      { name: "Chicken Caesar Salad", price: "$8", description: "" },
      { name: "Meatball Appetizer", price: "$6", description: "" },
      { name: "Garlic Bread", price: "$5", description: "" },
      { name: "Roasted Cauliflower", price: "$7", description: "" },
      { name: "Today's Soup", price: "$5", description: "", isActive: false },
      { name: "Spaghetti and Meatballs", price: "$8", description: "Half portion during Happy Hour." },
      { name: "Capellini Alla Primavera", price: "$6", description: "Half portion during Happy Hour.", isActive: false },
      { name: "Bottle Beer", price: "$4", description: "" },
      { name: "House Wine", price: "$4", description: "" },
      { name: "Classic Mule", price: "$5", description: "" },
      { name: "Old Fashioned", price: "$5", description: "" },
      { name: "Whiskey Cocktail", price: "$5", description: "" },
      { name: "Daiquiri", price: "$5", description: "" },
      { name: "Paloma", price: "$5", description: "" },
      { name: "Traditional Gin and Tonic", price: "$5", description: "" }
    ]
  }
];

export const cateringPackages = [
  "Gelato",
  "Wood fired pizza",
  "Gelato and wood fired pizza",
  "Panini",
  "Salads",
  "Gelato cakes"
];

export const faqs = [
  {
    question: "Are you the same Gelato Spot that used to be in Old Town Scottsdale?",
    answer:
      "Yes. The Gelato Spot moved to 32nd Street and Shea in Phoenix. It is the same family-owned restaurant with the same recipes and high-quality service."
  },
  {
    question: "Do you have gluten-free options?",
    answer:
      "Yes. Pizzas can be made with gluten-free dough for an additional cost. There are also gluten-free-friendly options such as meatballs, caprese, and several salads. The kitchen is not a certified gluten-free facility."
  },
  {
    question: "What kind of music is played at The Gelato Spot?",
    answer:
      "The team keeps a clean, family-friendly, multi-genre playlist for the restaurant. Other clean playlists may be used from time to time."
  },
  {
    question: "Where is The Gelato Spot located?",
    answer:
      "The current restaurant is at 10608 North 32nd Street in Phoenix, Arizona, at 32nd Street and Shea behind Walgreens."
  },
  {
    question: "How can I get in contact?",
    answer: "Call (602) 494-4010 during business hours or email hello@gelato.spot."
  },
  {
    question: "Can I have food delivered?",
    answer:
      "Yes. You can order through SkyTab or delivery partners including DoorDash, Grubhub, and Uber Eats."
  }
];

export const legalPages = {
  "privacy-policy": {
    title: "Privacy Policy",
    effectiveDate: "July 11, 2026",
    paragraphs: [
      "The Gelato Spot Wood Fired Pizzeria values your privacy. This policy explains how we collect, use, and protect your information when you visit gelato.spot, place online orders, or use related services.",
      "We may collect personal information such as name, phone number, email address, billing details, and delivery address when you place an order online. We may also collect order details, payment details, delivery or pickup preferences, IP address, browser type, device type, browsing behavior, and limited in-store Wi-Fi connection details.",
      "We use information to process and fulfill orders, improve the website and menu, communicate about promotions and updates when you opt in, maintain network security, and comply with legal requirements.",
      "When you join our updates list, we record the permission language shown to you, the date and time of consent, signup source, campaign attribution, IP address, and browser information. Email and text permissions are recorded separately. Text consent is optional and is not a condition of purchase.",
      "Before redirecting you to SkyTab, we may offer a separate optional email signup. Continuing to online ordering does not enroll you in marketing. You join only when you actively check the email permission box and submit your name and email address.",
      "We do not sell or rent personal information. Text messaging originator opt-in data and consent will not be shared with third parties or affiliates for their marketing or promotional purposes. We may share limited data with service providers, including Flygon LC and Twilio, solely to operate The Gelato Spot messaging program. Email signup data may be shared with Resend solely to maintain The Gelato Spot audience, deliver requested broadcasts, and process unsubscribes. We may also share limited data with third-party ordering platforms, analytics tools, or legal authorities when required.",
      "We use cookies and similar technologies to improve site functionality and analyze traffic. You may disable cookies in your browser, but some site features may not function properly.",
      "We use the Meta Pixel and Meta Conversions API to measure visits, menu and catering interest, online-order clicks, contact actions, and completed catering requests. These tools may use browser identifiers, ad click identifiers, IP address, device and browser details, and hashed versions of information you submit, such as your name, email address, or phone number, for advertising measurement and attribution.",
      "When a customer voluntarily provides an email address or phone number for a digital receipt or customer profile, we may use a hashed version of that contact information with purchase time, order identifier, and order value to measure advertising that led to an in-store purchase. We do not send card numbers, card tokens, security codes, or other payment credentials to Meta.",
      "We take reasonable measures to protect personal information from unauthorized access, disclosure, or misuse. No transmission or storage method is completely secure.",
      "You may opt out of promotional communications and may request access, correction, or deletion of your personal data by contacting us directly.",
      "Our online services are not directed at children under 13, although the restaurant is kid-friendly. We do not knowingly collect personal information from children.",
      "We may update this policy from time to time. Updates will be posted on this page with a revised effective date.",
      "Questions can be sent to The Gelato Spot Wood Fired Pizzeria at 10608 N 32nd Street, Phoenix, AZ 85028, or by calling (602) 494-4010."
    ]
  },
  "terms-and-conditions": {
    title: "Terms and Conditions",
    effectiveDate: "July 11, 2026",
    paragraphs: [
      "These terms govern your access to and use of gelato.spot, online ordering services, and related features, content, or functionality. By accessing or using the services, you agree to these terms.",
      "You may use the website and services only for lawful purposes. The services are intended for personal, non-commercial use by customers seeking food, beverages, and related information.",
      "Online ordering may be provided through SkyTab and third-party delivery providers such as DoorDash, Grubhub, and Uber Eats. Third-party platforms are governed by their own terms and policies.",
      "Continuing from our website to SkyTab confirms your agreement to these Terms and acknowledgment of our Privacy Policy. This acknowledgment is not permission to receive promotional email. Any marketing signup shown during the order handoff is separate, optional, and unchecked by default.",
      "Prices, menu items, and availability are subject to change without notice. The Gelato Spot is not responsible for third-party ordering errors, delays, pricing discrepancies, or service issues.",
      "Seating is available on a first-come, first-served basis unless otherwise stated. In-store Wi-Fi is provided as a courtesy, and customers should be respectful of staff, property, and other guests.",
      "Website content, including text, images, menus, logos, and designs, is the property of The Gelato Spot or its licensors and may not be copied, reproduced, or distributed without prior written consent.",
      "To the maximum extent permitted by law, The Gelato Spot is not liable for damages, losses, or claims resulting from use of the services, including online ordering, third-party delivery, or website performance.",
      "Food may contain allergens. Please review menu descriptions carefully and inform staff of dietary needs. Gluten-free options are offered, but the restaurant is not a certified gluten-free facility.",
      "The Gelato Spot text program provides recurring automated marketing messages about news, specials, flavors, and events. Message frequency varies. Message and data rates may apply. Consent is not a condition of purchase. Reply STOP to unsubscribe or HELP for help. You may also call (602) 494-4010 for assistance. Carriers are not liable for delayed or undelivered messages.",
      "Use of the services is also governed by the Privacy Policy.",
      "These terms are governed by the laws of the State of Arizona and the City of Phoenix. Questions can be sent to The Gelato Spot Wood Fired Pizzeria at 10608 N 32nd Street, Phoenix, AZ 85028, or by calling (602) 494-4010."
    ]
  }
};
